/* pj-tracking.js — camada central de eventos comportamentais (PostHog) do site Proper Jack.
 * v1.0 19/07/2026. Carregado pelo snippet pj-posthog.liquid em TODAS as páginas
 * EXCETO quiz/result (templates *diagnostic*), que têm tracking próprio (diagnostic.js).
 *
 * Princípios:
 *  - Wiring 100% por seletor/delegação — nenhuma seção precisa ser editada.
 *  - Tudo em try/catch: se o PostHog não carregar, o site não sente NADA.
 *  - Eventos custom têm prefixo pj_; page_type/page_template/theme_role vão como
 *    super props (registradas no pj-posthog.liquid).
 *  - Volume: seção/scroll/vídeo disparam UMA vez por pageview; hard cap de 300
 *    eventos custom por página como guarda contra loops.
 */
(function () {
  'use strict';
  if (window.__pjTrackLoaded) return; window.__pjTrackLoaded = true;

  var ctx = window.__pjCtx || {};
  var evCount = 0;
  var lastPointerT = 0; // último pointerdown real — filtra toggles programáticos de <details>

  function ph() { return (window.posthog && window.posthog.capture) ? window.posthog : null; }
  /* Corte de custo PostHog (25/08/2026): eventos de alto volume sem uso em painel
     nem A/B ativo, silenciados NA FONTE (wiring segue vivo — religar = tirar da
     lista). Somavam ~350k ev/mês: section_view 172k, engagement 80k, scroll 59k,
     gallery nav+thumb 38k. */
  var MUTED = { pj_section_view: 1, pj_scroll_depth: 1, pj_page_engagement: 1, pj_pv_gallery_thumb: 1, pj_pv_gallery_nav: 1 };
  function track(name, props, opts) {
    try {
      if (MUTED[name]) return;
      if (evCount >= 300) return;
      var p = ph(); if (!p) return;
      evCount++;
      props = props || {};
      /* contexto de página em CADA evento (NÃO como super prop — super prop
         persistiria e contaminaria os eventos do quiz com a página anterior) */
      if (props.page_type === undefined) props.page_type = ctx.page_type;
      if (props.page_template === undefined) props.page_template = ctx.template;
      p.capture(name, props, opts);
    } catch (_) {}
  }
  function txt(el, max) {
    try { return (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, max || 80); } catch (_) { return ''; }
  }

  /* ================= detecção de família de página =================
     Por DOM (auto-mantida) com fallback no template. As classes-raiz vêm do
     inventário das seções (ver pj-work\tracking-plan-site-novo.md). */
  var FAMILIES = window.__PJ_FAMILIES || []; // preenchido no bloco CONFIG abaixo
  var family = null;
  function detectFamily() {
    for (var i = 0; i < FAMILIES.length; i++) {
      try { if (document.querySelector(FAMILIES[i].root)) return FAMILIES[i]; } catch (_) {}
    }
    return null;
  }

  /* ================= pv_view ================= */
  function firePvView() {
    if (!family || !family.pv) return;
    var props = { pv: pvName(), pv_kind: family.kind };
    if (ctx.product) { props.pv_handle = ctx.product.handle; props.pv_price = ctx.product.price / 100; }
    track('pj_pv_view', props);
  }

  /* ================= scroll depth ================= */
  var scrollMarks = [25, 50, 75, 90], scrollFired = {}, maxScroll = 0, ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      try {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h <= 0) return;
        var pct = Math.round((window.scrollY / h) * 100);
        if (pct > maxScroll) maxScroll = pct;
        for (var i = 0; i < scrollMarks.length; i++) {
          var m = scrollMarks[i];
          if (pct >= m && !scrollFired[m]) { scrollFired[m] = 1; track('pj_scroll_depth', { depth: m }); }
        }
      } catch (_) {}
    });
  }

  /* ================= section views + dwell ================= */
  var sectionsSeen = [], dwell = {}, ioSections = null, observed = [];
  function watchSections() {
    if (!family || !family.sections || !('IntersectionObserver' in window)) return;
    if (!ioSections) {
      /* thresholds baixos + regra OR: seção conta como vista com 35% dela visível
         OU quando ela cobre metade do viewport — sem isso, seções mais altas que
         ~2.8 viewports (comuns no mobile) nunca atingiriam 35% */
      ioSections = new IntersectionObserver(function (entries) {
        var now = Date.now();
        entries.forEach(function (en) {
          var name = en.target.getAttribute('data-pj-sec');
          if (!name) return;
          var visto = en.isIntersecting && (en.intersectionRatio >= 0.35 ||
            (en.intersectionRect && en.intersectionRect.height >= window.innerHeight * 0.5));
          if (visto) {
            dwell[name] = dwell[name] || { t: 0, since: 0, seen: false };
            if (!dwell[name].since) dwell[name].since = now;
            if (!dwell[name].seen) {
              dwell[name].seen = true;
              sectionsSeen.push(name);
              track('pj_section_view', { section: name, position: sectionsSeen.length });
            }
          } else if (dwell[name] && dwell[name].since) {
            dwell[name].t += now - dwell[name].since; dwell[name].since = 0;
          }
        });
      }, { threshold: [0, 0.12, 0.25, 0.35] });
    }
    var list = family.sections.slice();
    list.push({ sel: '.pjf', name: 'footer' }); // footer global = chegou ao fim
    list.forEach(function (s) {
      try {
        var els = document.querySelectorAll(s.sel);
        for (var i = 0; i < els.length; i++) {
          var el = els[i];
          if (observed.indexOf(el) !== -1) continue;
          el.setAttribute('data-pj-sec', s.name + (i > 0 ? '_' + (i + 1) : ''));
          ioSections.observe(el); observed.push(el);
        }
      } catch (_) {}
    });
  }

  /* ================= engajamento no pageleave ================= */
  var engagementSent = false, tStart = Date.now();
  function sendEngagement() {
    if (engagementSent) return; engagementSent = true;
    try {
      var now = Date.now(), tops = [];
      for (var k in dwell) {
        var d = dwell[k], t = d.t + (d.since ? now - d.since : 0);
        tops.push([k, Math.round(t / 1000)]);
      }
      tops.sort(function (a, b) { return b[1] - a[1]; });
      var top3 = {}; tops.slice(0, 3).forEach(function (p) { top3[p[0]] = p[1]; });
      track('pj_page_engagement', {
        max_scroll: maxScroll,
        sections_viewed: sectionsSeen.length,
        sections_list: sectionsSeen.slice(0, 15).join(','),
        dwell_top: JSON.stringify(top3),
        time_on_page_s: Math.round((now - tStart) / 1000)
      }, { transport: 'sendBeacon' });
    } catch (_) {}
  }

  /* ================= interceptação de carrinho (fetch + XHR) =================
     Pega TODA mutação de carrinho do site (PVs, bumps, kit builder, /cart),
     independente de qual código disparou. */
  function numOr(v, dflt) { return (v == null || v === '' || isNaN(+v)) ? dflt : +v; }
  function parseCartBody(body) {
    try {
      if (!body) return {};
      if (typeof body === 'string') {
        if (body.charAt(0) === '{') {
          var j = JSON.parse(body);
          if (j.items) return { ids: j.items.map(function (i) { return i.id; }).join(','), qty: j.items.reduce(function (a, i) { return a + numOr(i.quantity, 1); }, 0) };
          /* ATENÇÃO: em /cart/change o id é a LINE KEY, não variant id — e
             quantity: 0 = remoção (não pode virar 1) */
          return { ids: String(j.id || ''), qty: numOr(j.quantity, 1), line: j.line };
        }
        var sp = new URLSearchParams(body);
        return { ids: sp.get('id') || '', qty: numOr(sp.get('quantity'), 1), line: sp.get('line') || undefined };
      }
      if (body instanceof FormData || body instanceof URLSearchParams) {
        var g = function (k) { try { return body.get(k); } catch (_) { return null; } };
        return { ids: g('id') || '', qty: numOr(g('quantity'), 1), line: g('line') || undefined };
      }
    } catch (_) {}
    return {};
  }
  function cartEvent(url, body, status) {
    try {
      var u = String(url);
      var info = parseCartBody(body);
      var base = { endpoint: u.split('?')[0], status: status };
      if (info.ids) base.ids = String(info.ids); /* add: variant id(s); change: line key */
      if (info.qty != null) base.quantity = info.qty;
      if (!status || status >= 400) { track('pj_cart_error', base); return; }
      if (u.indexOf('/cart/add') !== -1) track('pj_cart_add', base);
      else if (u.indexOf('/cart/change') !== -1) track(info.qty === 0 ? 'pj_cart_remove' : 'pj_cart_qty', base);
      else if (u.indexOf('/cart/update') !== -1) track('pj_cart_update', base);
      else if (u.indexOf('/cart/clear') !== -1) track('pj_cart_clear', base);
    } catch (_) {}
  }
  function isCartUrl(u) { return /\/cart\/(add|change|update|clear)/.test(String(u)); }
  function isYeverUrl(u) { return String(u).indexOf('api.yever.com.br') !== -1 && String(u).indexOf('/checkout') !== -1; }

  var lastCheckoutT = 0; // último clique real em FINALIZAR — gate do pj_checkout_error
  try {
    if (typeof window.fetch === 'function') {
      var _fetch = window.fetch;
      window.fetch = function (input, init) {
        var url = '';
        try { url = (typeof input === 'string') ? input : String((input && input.url) || input || ''); } catch (_) {}
        var body = init && init.body;
        var pr = _fetch.apply(this, arguments);
        if (isCartUrl(url)) {
          pr.then(function (resp) { cartEvent(url, body, resp.status); }, function () { cartEvent(url, body, 0); });
        } else if (isYeverUrl(url)) {
          /* o side cart faz PRE-WARM no mesmo endpoint a cada abertura/mudança —
             só é erro de CHECKOUT se houve clique em finalizar há <30s */
          pr.then(function (resp) {
            if (!resp.ok && Date.now() - lastCheckoutT < 30000) track('pj_checkout_error', { kind: 'http', status: resp.status });
          }, function (err) {
            if (Date.now() - lastCheckoutT < 30000) track('pj_checkout_error', { kind: (err && err.name === 'AbortError') ? 'timeout' : 'network' });
          });
        }
        return pr;
      };
    }
  } catch (_) {}

  try {
    var _open = XMLHttpRequest.prototype.open, _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__pjUrl = u; return _open.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function (body) {
      var xhr = this, u = xhr.__pjUrl;
      if (u && isCartUrl(u)) {
        xhr.addEventListener('loadend', function () { cartEvent(u, body, xhr.status); }, { once: true });
      }
      return _send.apply(this, arguments);
    };
  } catch (_) {}

  /* ================= vídeos ================= */
  var vidState = new WeakMap();
  function vidLabel(v) {
    try {
      var sec = v.closest('[data-pj-sec]');
      var src = (v.currentSrc || v.src || '').split('/').pop().split('?')[0];
      return { video: src.slice(0, 60), section: sec ? sec.getAttribute('data-pj-sec') : undefined };
    } catch (_) { return {}; }
  }
  document.addEventListener('play', function (e) {
    var v = e.target; if (!v || v.tagName !== 'VIDEO') return;
    /* vídeos decorativos de background (autoplay+muted, tipo hero da home)
       NÃO são engajamento — ignora, senão vira lixo em escala */
    if (v.autoplay && v.muted && !v.controls) return;
    var st = vidState.get(v) || { played: false, marks: {} };
    if (!st.played) { st.played = true; var l = vidLabel(v); l.action = 'play'; track('pj_video', l); }
    vidState.set(v, st);
  }, true);
  document.addEventListener('timeupdate', function (e) {
    var v = e.target; if (!v || v.tagName !== 'VIDEO' || !v.duration) return;
    var st = vidState.get(v); if (!st) return;
    var pct = (v.currentTime / v.duration) * 100;
    [25, 50, 75, 95].forEach(function (m) {
      if (pct >= m && !st.marks[m]) { st.marks[m] = 1; var l = vidLabel(v); l.action = 'progress'; l.pct = m; track('pj_video', l); }
    });
  }, true);

  /* ================= formulários ================= */
  document.addEventListener('submit', function (e) {
    try {
      var f = e.target; if (!f || f.tagName !== 'FORM') return;
      /* busca (overlay do header ou drawer do tema) */
      if ((f.getAttribute('action') || '').indexOf('/search') !== -1 || f.closest('.pjhd-so, .search-bar-container')) {
        var q = f.querySelector('input[name="q"]');
        track('pj_search_submit', { term: q ? String(q.value).slice(0, 80) : '', source: f.closest('.pjhd-so') ? 'header' : 'drawer' });
        return;
      }
      var formType = (f.querySelector('input[name="form_type"]') || {}).value || '';
      if (formType === 'customer') {
        var emailInput = f.querySelector('input[name="contact[email]"], input[type="email"]');
        track('pj_newsletter_signup', { source: f.closest('.pjf') ? 'footer' : (f.closest('.yv-newsletter-popup') ? 'popup' : 'outro') });
        if (emailInput && /.+@.+\..+/.test(emailInput.value || '') && window.posthog && window.posthog.identify) {
          /* mesmo padrão do quiz: identify por email liga ao purchase server-side */
          try { window.posthog.identify(emailInput.value.trim().toLowerCase()); } catch (_) {}
        }
      } else if (formType === 'contact') {
        track('pj_contact_submit', {});
      }
    } catch (_) {}
  }, true);

  /* ================= busca (página de resultados) ================= */
  function fireSearch() {
    if (ctx.search && ctx.search.performed) {
      track('pj_search', { term: (ctx.search.terms || '').slice(0, 80), results: ctx.search.count });
      if (ctx.search.count === 0) track('pj_search_empty', { term: (ctx.search.terms || '').slice(0, 80) });
    }
  }

  /* ================= cliques delegados (regras do CONFIG) ================= */
  var CLICK_RULES = window.__PJ_CLICK_RULES || []; // preenchido no bloco CONFIG
  document.addEventListener('click', function (e) {
    try {
      var t = e.target; if (!t || !t.closest) return;
      if (t.closest('[data-sc-checkout]')) lastCheckoutT = Date.now();
      /* WhatsApp em qualquer lugar */
      var wa = t.closest('a[href*="wa.me"], a[href*="api.whatsapp.com"]');
      if (wa) { track('pj_whatsapp_click', { label: txt(wa, 40) }); return; }
      for (var i = 0; i < CLICK_RULES.length; i++) {
        var r = CLICK_RULES[i], el = null;
        try { el = t.closest(r.sel); } catch (_) { continue; }
        if (!el) continue;
        var props = {};
        try { props = r.props ? r.props(el, t) : {}; } catch (_) {}
        if (r.label !== false && !props.label) props.label = txt(el, 60);
        track(r.ev, props);
        return; // primeira regra que casa ganha
      }
    } catch (_) {}
  }, true);

  /* ================= <details>/accordions nativos =================
     Só conta se houve pointerdown humano há <1,5s: os PVs/FAQs abrem e fecham
     details PROGRAMATICAMENTE (matchMedia no resize, accordion exclusivo
     fechando irmãos) e isso dispararia toggles fantasmas. */
  document.addEventListener('toggle', function (e) {
    try {
      var d = e.target;
      if (d && d.tagName === 'DETAILS' && d.open && (Date.now() - lastPointerT) < 1500) {
        var s = d.querySelector('summary');
        track('pj_accordion_open', { label: s ? txt(s, 60) : '' });
      }
    } catch (_) {}
  }, true);

  /* ================= drawer do carrinho ================= */
  var SC = window.__PJ_SIDECART || null; // {root, openClass} — preenchido no CONFIG
  var scOpen = false, scWatched = null;
  function watchSideCart() {
    if (!SC || !('MutationObserver' in window)) return;
    var el = document.querySelector(SC.root); if (!el || el === scWatched) return;
    scWatched = el;
    var mo = new MutationObserver(function () {
      try {
        var open = el.classList.contains(SC.openClass);
        if (open && !scOpen) { scOpen = true; track('pj_cart_open', { items: (ctx.cart || {}).count }); }
        else if (!open && scOpen) { scOpen = false; track('pj_cart_close', {}); }
      } catch (_) {}
    });
    mo.observe(el, { attributes: true, attributeFilter: ['class'] });
  }

  /* ================= mudanças de estado (change delegado) ================= */
  var CHANGE_RULES = window.__PJ_CHANGE_RULES || []; // preenchido no CONFIG
  document.addEventListener('change', function (e) {
    try {
      var t = e.target; if (!t || !t.closest) return;
      for (var i = 0; i < CHANGE_RULES.length; i++) {
        var r = CHANGE_RULES[i], el = null;
        try { el = t.closest(r.sel); } catch (_) { continue; }
        if (!el) continue;
        var props = {};
        try { props = r.props ? r.props(el, t) : {}; } catch (_) {}
        track(r.ev, props);
        return;
      }
    } catch (_) {}
  }, true);

  /* ================= boot ================= */
  function boot() {
    family = detectFamily();
    /* a kits-vip registra super prop persistente catalog_page que vaza pras
       outras páginas — limpa fora dela */
    try {
      if ((!family || family.kind !== 'kitsvip') && window.posthog && window.posthog.unregister) window.posthog.unregister('catalog_page');
    } catch (_) {}
    if (ctx.page_type === '404') track('pj_404_view', { path: location.pathname, ref: document.referrer.slice(0, 120) });
    /* form de contato: sucesso/erro renderizados server-side no reload */
    try {
      if (document.querySelector('.pjct-success')) track('pj_contact_success', {});
      else if (document.querySelector('.pjct-errors')) track('pj_contact_error', {});
    } catch (_) {}
    firePvView();
    fireSearch();
    watchSections();
    watchSideCart();
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    /* seções renderizadas tarde (JS) — re-scan */
    setTimeout(watchSections, 2500);
    setTimeout(watchSideCart, 2500);
    setTimeout(watchSections, 6000);
    window.addEventListener('pagehide', sendEngagement);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        /* fecha os intervalos de dwell abertos — tempo em background não conta */
        try { var now = Date.now(); for (var k in dwell) { if (dwell[k].since) { dwell[k].t += now - dwell[k].since; dwell[k].since = 0; } } } catch (_) {}
        sendEngagement();
      }
    });
    /* volta de bfcache: re-arma engajamento e zera timers (sem re-disparar section_view) */
    window.addEventListener('pageshow', function (ev) {
      if (ev.persisted) {
        engagementSent = false; tStart = Date.now(); maxScroll = 0;
        try { for (var k in dwell) { dwell[k].t = 0; dwell[k].since = 0; } } catch (_) {}
      }
    });
  }

  /* =====================================================================
     CONFIG — gerado a partir do inventário das seções (19/07/2026).
     Ver doc: memoria claude\pj-work\tracking-plan-site-novo.md
     Regra de ouro: NUNCA duplicar eventos que as seções já capturam inline
     (pj_home_cta, pj_kit_{dor}_*, pj_{unit}_*, pj_catalog_*, pj_kitbuilder,
      pj_quiz_*) — aqui só entram os GAPS e a camada padronizada.
     ===================================================================== */

  function dataset(el, k) { try { return el.getAttribute(k) || undefined; } catch (_) { return undefined; } }
  function pvName() {
    if (ctx.page_handle) return String(ctx.page_handle).replace(/-vendas$/, '');
    if (ctx.product) return ctx.product.handle;
    return undefined;
  }

  FAMILIES = [
    { root: 'section.pjk', kind: 'kitpv', pv: true, sections: [
      { sel: '.pjk-buy', name: 'modulo_compra' }, { sel: '.pjk-results', name: 'antes_depois' },
      { sel: '.pjk-band', name: 'band_editorial' }, { sel: '.pjk-fit', name: 'para_quem' },
      { sel: '.pjk-inside', name: 'o_que_vem' }, { sel: '.pjk-routine', name: 'rotina' },
      { sel: '.pjk-effi', name: 'eficacia' }, { sel: '.pjk-sci', name: 'ciencia' },
      { sel: '.pjk-reviews', name: 'reviews' }, { sel: '.pjk-faqsec', name: 'faq' },
      { sel: '.pjk-finalcta', name: 'cta_final' } ] },
    { root: 'section.pjl', kind: 'unitpv', pv: true, sections: [
      { sel: '.pjl-buy', name: 'modulo_compra' }, { sel: '.pjl-band', name: 'band_editorial' },
      { sel: '.pjl-fit', name: 'para_quem' }, { sel: '.pjl-ativos', name: 'ativos' },
      { sel: '.pjl-howto', name: 'como_usar' }, { sel: '.pjl-sci', name: 'ciencia' },
      { sel: '.pjl-exp', name: 'especialistas' }, { sel: '.pjl-reviews', name: 'reviews' },
      { sel: '.pjl-faqsec', name: 'faq' }, { sel: '.pjl-finalcta', name: 'cta_final' } ] },
    { root: 'section.pjsh', kind: 'shampoo', pv: true, sections: [
      { sel: '.pjsh-buy', name: 'modulo_compra' }, { sel: '.pjsh-band', name: 'band_editorial' },
      { sel: '.pjsh-pillars', name: 'pilares' }, { sel: '.pjsh-timeline', name: 'timeline' },
      { sel: '.pjsh-claims', name: 'claims' }, { sel: '.pjsh-ingred', name: 'ingredientes' },
      { sel: '.pjsh-howto', name: 'como_usar' }, { sel: '.pjsh-reviews', name: 'reviews' },
      { sel: '.pjsh-faqsec', name: 'faq' }, { sel: '.pjsh-finalcta', name: 'cta_final' } ] },
    { root: '.pjh-hero2', kind: 'home', sections: [
      { sel: '.pjh-hero2', name: 'hero' }, { sel: '.pjh-press', name: 'imprensa' },
      { sel: '.pjh-dores', name: 'dores' }, { sel: '.pjh-corg', name: 'banner_coringa' },
      { sel: '.pjh-claims', name: 'claims' }, { sel: '.pjh-units', name: 'unitarios' },
      { sel: '.pjh-kitbn', name: 'banner_montekit' }, { sel: '.pjh-gifts', name: 'presentes' },
      { sel: '.pjh-quizbn', name: 'banner_quiz' }, { sel: '.pjh-ad', name: 'antes_depois' },
      { sel: '.pjh-reviews', name: 'reviews' }, { sel: '.pjh-sci', name: 'ciencia' } ] },
    { root: '.pjkb-hero', kind: 'builder', sections: [
      { sel: '.pjkb-hero', name: 'hero' }, { sel: '.pjkb-products', name: 'produtos' },
      { sel: '.pjkb-faqsec', name: 'faq' } ] },
    { root: '.pjca-hero', kind: 'catalogo', sections: [
      { sel: '.pjca-hero', name: 'hero' }, { sel: '.pjca-products', name: 'grid' },
      { sel: '.pjca-kitsec', name: 'banner_montekit' } ] },
    { root: '.pjcat', kind: 'kitsvip', sections: [
      { sel: '.pjc-trust', name: 'trust' }, { sel: '#pjc-kits', name: 'grid_kits' },
      { sel: '.pjc-ba', name: 'antes_depois' }, { sel: '.pjc-quizband', name: 'banda_quiz' },
      { sel: '.pjc-guar', name: 'garantia' } ] },
    { root: '.pj-search-v2', kind: 'busca', sections: [] },
    { root: '.pjnf', kind: 'p404', sections: [] },
    { root: '.pjab-hero', kind: 'sobre', sections: [
      { sel: '.pjab-hero', name: 'hero' }, { sel: '.pjab-sec.pjab-split', name: 'historia' },
      { sel: '.pjab-values', name: 'valores' }, { sel: '.pjab-team', name: 'time' },
      { sel: '.pjab-cta', name: 'cta_final' } ] },
    { root: '.pjfaq-hero', kind: 'faq', sections: [{ sel: '.pjfaq-group', name: 'grupo' }] },
    { root: '.pjct-head', kind: 'contato', sections: [] },
    { root: '.pjas-hero', kind: 'assinatura', sections: [
      { sel: '.pjas-hero', name: 'hero' }, { sel: '.pjas-steps', name: 'passos' },
      { sel: '.pjas-panel', name: 'painel' }, { sel: '.pjas-faq', name: 'faq' },
      { sel: '.pjas-cta', name: 'cta_final' } ] },
    { root: '[data-cart-form], [data-cart-empty]', kind: 'cart_page', sections: [] }
  ];

  CLICK_RULES = [
    /* ---- side cart (handlers internos usam stopPropagation → só capture pega) ---- */
    { sel: '#pj-sc [data-sc-checkout]', ev: 'pj_cart_checkout_click', label: false,
      props: function () { return { source: 'sidecart', items: (ctx.cart || {}).count }; } },
    { sel: '#pj-sc [data-sc-upsell-add]', ev: 'pj_cart_bump_add', label: false,
      props: function (el) {
        var modal = el.closest('[data-sc-dmodal]'), name;
        if (modal) { var n = modal.querySelector('[data-sc-dmodal-name]'); if (n) name = txt(n, 40); }
        else { var item = el.closest('.pj-sc-upsell-item'); var t = item ? item.querySelector('.pj-sc-upsell-title') : null; if (t) name = txt(t, 40); }
        return { bump: name, variant_id: dataset(el, 'data-sc-upsell-add'), from_modal: !!modal };
      } },
    { sel: '#pj-sc [data-sc-detail]', ev: 'pj_cart_bump_detail', label: false,
      props: function (el) { return { bump: dataset(el, 'data-up-title') || txt(el, 40) }; } },
    { sel: '#pj-sc [data-dmodal-thumb]', ev: 'pj_cart_bump_thumb', label: false,
      props: function (el) { return { foto: dataset(el, 'aria-label') }; } },
    { sel: '#pj-sc [data-sc-cep-go]', ev: 'pj_cart_cep_calc', label: false, props: function () { return {}; } },

    /* ---- header / chrome ---- */
    { sel: '[data-pjhd-so-open]', ev: 'pj_search_open', label: false, props: function () { return { source: 'header' }; } },
    { sel: '[data-pjhd-burger]', ev: 'pj_menu_toggle', label: false, props: function () { return {}; } },
    { sel: '.pjhd-menu-link, .pjhd-menu-account, .pjhd-cta, .pjhd-link', ev: 'pj_nav_click',
      props: function (el) { return { area: 'header', href: el.getAttribute('href') || '' }; } },
    { sel: '.pjf-social a', ev: 'pj_social_click', props: function (el) { return { rede: dataset(el, 'aria-label') }; } },
    { sel: '.cookies-banner-btn .secondary-button', ev: 'pj_cookie_accept', label: false, props: function () { return {}; } },
    { sel: '.cookies-banner-btn .button:not(.secondary-button)', ev: 'pj_cookie_decline', label: false, props: function () { return {}; } },
    { sel: '.yv-newsletter-popup .pop_cross', ev: 'pj_newsletter_popup_close', label: false, props: function () { return {}; } },
    /* o submit do popup é programático (preventDefault+form.submit — não emite 'submit') */
    { sel: '.yv-newsletter-popup button[name="commit"], #SubscribeBtn', ev: 'pj_newsletter_signup', label: false,
      props: function (el) {
        try {
          var f = el.closest('form'), em = f ? f.querySelector('input[type="email"], input[name="contact[email]"]') : null;
          if (em && /.+@.+\..+/.test(em.value || '') && window.posthog && window.posthog.identify) window.posthog.identify(em.value.trim().toLowerCase());
        } catch (_) {}
        return { source: 'popup' };
      } },
    { sel: '.search-bar-container a, [data-search-suggestions] a', ev: 'pj_search_result_click',
      props: function (el) { return { href: el.getAttribute('href') || '' }; } },

    /* ---- PV kit (gaps; inline pj_kit_{dor}_* segue como está) ---- */
    { sel: '.pjk-freq-btn', ev: 'pj_kitpv_freq_select', label: false,
      props: function (el) { return { freq: dataset(el, 'data-freq'), pv: pvName() }; } },
    { sel: '#pjkCta', ev: 'pj_pv_cta_click', label: false, props: function () { return { source: 'main', pv: pvName() }; } },
    { sel: '#pjkStickyCta', ev: 'pj_pv_cta_click', label: false, props: function () { return { source: 'sticky', pv: pvName() }; } },
    { sel: '.pjk-sticky-pill', ev: 'pj_kitpv_sticky_level', label: false,
      props: function (el) { return { level: dataset(el, 'data-level') || txt(el, 10), pv: pvName() }; } },
    { sel: '.pjk-gal-thumb, .pjl-gal-thumb, .pjsh-gal-thumb', ev: 'pj_pv_gallery_thumb', label: false,
      props: function (el) { return { foto: dataset(el, 'aria-label'), pv: pvName() }; } },
    { sel: '[data-gal-prev], [data-gal-next], .pjk-gal-arrow', ev: 'pj_pv_gallery_nav', label: false,
      props: function (el) { return { dir: el.hasAttribute('data-gal-prev') ? 'prev' : 'next', pv: pvName() }; } },
    { sel: '#pjkGalMain, #pjlGalMain, #pjshGalMain', ev: 'pj_pv_lightbox_open', label: false,
      props: function () { return { pv: pvName() }; } },
    { sel: '[data-rt2-comp], .pjk-rt2-comp-btn', ev: 'pj_pv_composition_open', label: false,
      props: function (el) { return { produto: dataset(el, 'data-comp-name'), pv: pvName() }; } },
    { sel: '[data-rev-filter]', ev: 'pj_pv_reviews_filter', label: false,
      props: function (el) { return { filtro: dataset(el, 'data-rev-filter'), pv: pvName() }; } },
    { sel: '[data-pjk-okendo-more], [data-pjl-okendo-more], [data-pjsh-okendo-more]', ev: 'pj_pv_reviews_more',
      label: false, props: function () { return { pv: pvName() }; } },
    { sel: '.pjk-ins-arrow, .pjk-ad-arrow', ev: 'pj_pv_slider_nav', label: false,
      props: function (el) { return { slider: el.className.indexOf('ins') !== -1 ? 'produtos' : 'resultados', pv: pvName() }; } },
    { sel: '.pjk-fit-cta, .pjl-fit-cta', ev: 'pj_pv_quiz_cta', label: false, props: function () { return { pv: pvName() }; } },

    /* ---- PV unit (gaps; inline pj_{unit}_* segue) ---- */
    { sel: '#pjlCta', ev: 'pj_pv_cta_click', label: false, props: function () { return { source: 'main', pv: pvName() }; } },
    { sel: '#pjlStickyCta', ev: 'pj_pv_cta_click', label: false, props: function () { return { source: 'sticky', pv: pvName() }; } },
    { sel: '.pjl-sticky-pill', ev: 'pj_pv_sticky_pack', label: false,
      props: function (el) { return { qty: dataset(el, 'data-q'), pv: pvName() }; } },
    { sel: '[data-pjl-inci-open]', ev: 'pj_pv_composition_open', label: false, props: function () { return { pv: pvName() }; } },
    { sel: '.pjl-qty-btn', ev: 'pj_pv_qty_change', label: false,
      props: function (el) { return { dir: el.hasAttribute('data-qty-plus') ? 'plus' : 'minus', pv: pvName() }; } },

    /* ---- shampoo ---- */
    { sel: '#pjshCta', ev: 'pj_pv_cta_click', label: false, props: function () { return { source: 'main', pv: pvName() }; } },
    { sel: '#pjshStickyCta', ev: 'pj_pv_cta_click', label: false, props: function () { return { source: 'sticky', pv: pvName() }; } },

    /* ---- home (só o que o pj_home_cta inline NÃO cobre) ---- */
    { sel: '.pjh-ad [data-pjh-slide]', ev: 'pj_slider_nav', label: false, props: function () { return { slider: 'antes_depois_home' }; } },

    /* ---- Monte seu Kit (gaps; inline pj_kitbuilder{tier_up,add_to_cart} segue) ---- */
    { sel: '[data-pjkb-tab]', ev: 'pj_builder_tab', label: false, props: function (el) { return { tab: dataset(el, 'data-pjkb-tab') }; } },
    { sel: '[data-pjkb-info]', ev: 'pj_builder_detail', label: false,
      props: function (el) { var c = el.closest('.pjkb-card'); return { produto: c ? dataset(c, 'data-name') : undefined, source: 'botao' }; } },
    { sel: '[data-pjkb-add]', ev: 'pj_builder_add', label: false,
      props: function (el) { var c = el.closest('.pjkb-card'); return c ? { produto: dataset(c, 'data-name'), cat: dataset(c, 'data-cat'), variant_id: dataset(c, 'data-vid') } : {}; } },
    { sel: '[data-pjkb-plus], [data-pjkb-minus]', ev: 'pj_builder_qty', label: false,
      props: function (el) { var c = el.closest('.pjkb-card'); return { produto: c ? dataset(c, 'data-name') : undefined, dir: el.hasAttribute('data-pjkb-plus') ? 'plus' : 'minus' }; } },
    { sel: '.pjkb-card-media', ev: 'pj_builder_detail', label: false,
      props: function (el) { var c = el.closest('.pjkb-card'); return { produto: c ? dataset(c, 'data-name') : undefined, source: 'imagem' }; } },
    { sel: '[data-pjkb-madd]', ev: 'pj_builder_modal_add', label: false,
      props: function () { var n = document.querySelector('#pjkbModal .pjkb-m-name'); return { produto: n ? txt(n, 40) : undefined }; } },
    { sel: '.pjkb-m-pdp', ev: 'pj_builder_pdp_click', label: false,
      props: function (el) { return { href: el.getAttribute('href') || '' }; } },
    { sel: '#pjkbCta', ev: 'pj_builder_cta_click', label: false, props: function () { return {}; } },

    /* ---- catálogo todos (gap: clique no card; tabs/quick-add já têm inline) ---- */
    { sel: '.pjca-card-link', ev: 'pj_catalog_product_click', label: false,
      props: function (el) { var c = el.closest('.pjca-card'); return { produto: c ? txt(c.querySelector('.pjca-card-name'), 50) : undefined, cat: c ? dataset(c, 'data-cat') : undefined }; } },

    /* ---- busca / busca vazia / 404 ---- */
    { sel: '.pj-search-v2 [data-product-grid] a, .pj-search-v2 #CollectionProductsContainer a', ev: 'pj_search_result_click',
      props: function (el) { return { href: el.getAttribute('href') || '', term: (ctx.search || {}).terms }; } },
    { sel: '.pjse-pop-chips a', ev: 'pj_search_suggestion', props: function () { return { term_original: (ctx.search || {}).terms }; } },
    { sel: '.pjse-ctas .pjse-btn', ev: 'pj_search_empty_cta',
      props: function (el) { return { target: el.classList.contains('pjse-btn--ghost') ? 'catalogo' : 'quiz' }; } },
    { sel: '.pjnf-pop-chips a', ev: 'pj_404_suggestion', props: function () { return { path: location.pathname }; } },
    { sel: '.pjnf-ctas .pjnf-btn', ev: 'pj_404_cta',
      props: function (el) { return { target: el.classList.contains('pjnf-btn--ghost') ? 'catalogo' : 'quiz', path: location.pathname }; } },
    { sel: '.pjnf-home', ev: 'pj_404_cta', label: false, props: function () { return { target: 'home', path: location.pathname }; } },

    /* ---- /cart (página) ---- */
    { sel: '[id="cartCheckoutympButton"]', ev: 'pj_cart_checkout_click', label: false,
      props: function () { return { source: 'cart_page', items: (ctx.cart || {}).count }; } },

    /* ---- assinatura LP (painel ANTES do primary: o CTA do painel também tem
            .pjas-btn--primary e seria engolido pela regra genérica) ---- */
    { sel: '.pjas a[href*="assinatura.properjack.com.br"]', ev: 'pj_assinatura_painel', label: false,
      props: function (el) { return { position: el.closest('.pjas-panel') ? 'painel' : 'faq' }; } },
    { sel: '.pjas-btn--primary', ev: 'pj_assinatura_cta', label: false,
      props: function (el) { return { position: el.closest('.pjas-hero') ? 'hero' : 'cta_final' }; } }
  ];

  CHANGE_RULES = [
    { sel: '#GiftWrapProduct', ev: 'pj_cart_gift_wrap', props: function (el) { return { on: !!el.checked }; } }
  ];

  SC = { root: '#pj-sc', openClass: 'is-open' };

  /* ---- interações que não são clique ---- */

  /* troca de nível nos PVs de kit: evento custom da própria seção (fonte limpa,
     sem duplicar os cliques inflados do inline level_select) */
  var lastLevel = null;
  /* capture=true OBRIGATÓRIO: a seção dispara o CustomEvent no root SEM bubbles —
     só a fase de captura desce até o target */
  document.addEventListener('pjk:level', function (e) {
    try {
      var lv = e.detail && e.detail.level;
      if (lv && lv !== lastLevel) { lastLevel = lv; track('pj_kitpv_level', { level: lv, pv: pvName() }); }
    } catch (_) {}
  }, true);

  /* drag no comparador antes/depois da home — 1x por card */
  var baDragged = [];
  document.addEventListener('pointerdown', function (e) {
    try {
      lastPointerT = Date.now();
      var h = e.target && e.target.closest ? e.target.closest('.pjh-cmp-handle') : null;
      if (h && baDragged.indexOf(h) === -1) { baDragged.push(h); track('pj_ba_drag', { onde: 'home' }); }
    } catch (_) {}
  }, { capture: true, passive: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
